import React from 'react';
import { Box, Button as MuiButton, Typography, IconButton, Tooltip } from '@mui/material';
import { docGeniusPalette } from 'styles/partials/colors';
import Button from 'components/Button/Button';
import { ModalProps } from '../ModalFactory';
import { useDeleteDocumentMutation } from 'features/document/documentApi';
import { useDeleteTemplateMutation } from 'features/template/templateApi';
import { CloseRounded } from '@mui/icons-material';

export default function DeleteModalContent(props: ModalProps) {
  const { onClose, modalData } = props;
  const [deleteDocument] = useDeleteDocumentMutation();
  const [deleteTemplate] = useDeleteTemplateMutation();

  const deleteDocumentById = () => {
    const { id, isTemplate } = modalData;
    if (isTemplate) {
      deleteTemplate(id);
    } else {
      deleteDocument(id);
    }
    onClose();
  };

  return (
    <Box alignItems={'self-end'} display={'flex'} flexDirection={'column'}>
      <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'} width={'100%'}>
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          fontSize='24px'
          sx={{ color: docGeniusPalette.neutralGray }}
        >
          Delete File?
        </Typography>
        <Tooltip title='Close' arrow>
          <IconButton aria-label='' onClick={onClose}>
            <CloseRounded color='primary' />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography id='modal-modal-description' marginTop={'24px'}>
        By doing this, the file will be permanently removed.
      </Typography>
      <Box display={'flex'} gap={'16px'} marginTop={'64px'}>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <MuiButton
          color='error'
          variant='contained'
          onClick={deleteDocumentById}
          disableElevation
          sx={{ textTransform: 'none' }}
        >
          Delete File
        </MuiButton>
      </Box>
    </Box>
  );
}
